import request from '@/services/request'

export default {
  monthFees: {
    url: '/storage/monthFees',
    method: 'post',
    desc: '月度仓储费初始数据'
  },
  getDate: {
    url: '/storage/monthFees/getDate',
    method: 'get',
    desc: '月度仓储费初始时间'
  },
  fbaInventoryAged: {
    url: '/fbaInventoryAged/page',
    method: 'post',
    desc: 'fba库龄初始数据'
  },
  longTermStorageFee: {
    url: '/longTermStorageFee/page',
    method: 'post',
    desc: '长期仓储费初始数据'
  },
  /**
   * 获取仓库列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchWarehouseList: (data, options = {}) => {
    return request(
      {
        url: '/warehouse/list',
        method: 'post',
        desc: '获取仓库列表'
      },
      data,
      options
    )
  },
  /**
   * 获取进销存明细列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchWarehousePurchaseSalesStockDetailList: (data, options = {}) => {
    return request(
      {
        url: '/warehouse/inventory/item',
        method: 'post',
        desc: '获取进销存明细列表'
      },
      data,
      options
    )
  },
  /**
   * 进销存明细-初始化
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchInitWarehousePurchaseSalesStockDetail: (data, options = {}) => {
    return request(
      {
        url: '/warehouse/inventory/init',
        method: 'post',
        desc: '进销存明细-初始化'
      },
      data,
      options
    )
  },
  /**
   * 进销存明细-状态
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchWarehousePurchaseSalesStockDetailStatus: (data, options = {}) => {
    return request(
      {
        url: '/warehouse/inventory/status',
        method: 'post',
        desc: '进销存明细-状态'
      },
      data,
      options
    )
  },
  /**
   * 进销存报表-列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchPSSReportList: (data, options = {}) => {
    return request(
      {
        url: '/warehouse/inventory/report ',
        method: 'post',
        desc: '进销存报表-列表'
      },
      data,
      options
    )
  },
}
